module.exports = __webpack_public_path__ + "dfdba8895715053b9568c625497e7697.svg";